<template>
  <div>
    <!-- 编辑、添加界面 -->
    <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="600px" :destroy-on-close="true"
      :before-close="cancel">
      <div class="el-dialog-div">
        <el-form label-width="105px" ref="form" :model="form" :rules="rules">
          <el-form-item label="公司名称:" prop="companyName">
            <el-input  v-model="form.companyName" placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-form-item label="限额:" prop="quota">
            <el-input  v-model="form.quota" placeholder="请输入发票总额度"></el-input>
          </el-form-item>
          <el-form-item label="纳税人识别号:" prop="taxpayerNumber">
            <el-input  v-model="form.taxpayerNumber" placeholder="请输入纳税人识别号"></el-input>
          </el-form-item>
          <el-form-item label="地址:" prop="companyAddress" style="width: 100%;">
            <el-input :autosize="{ minRows: 3 }" type="textarea" placeholder="请输入地址" v-model="form.companyAddress"
              maxlength="300" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="电话:" prop="phone">
            <el-input  v-model="form.phone" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="开户行:" prop="depositBank">
            <el-input  v-model="form.depositBank" placeholder="请输入开户行名称">
            </el-input>
          </el-form-item>
          <el-form-item label="银行账号:" prop="bankAccount">
            <el-input  v-model="form.bankAccount" placeholder="请输入银行账号"></el-input>
          </el-form-item>
          <el-form-item label="行号:" prop="bankLineNumber">
            <el-input  v-model="form.bankLineNumber" placeholder="请输入行号"></el-input>
          </el-form-item>
          <el-form-item label="备注:" prop="remark">
            <el-input :autosize="{ minRows: 3}" type="textarea" placeholder="请输入内容" v-model="form.remark"
              maxlength="300" show-word-limit>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="handle">保存</el-button>
      </div>
    </el-dialog>
    <loading :loading="loading" load-text="提交中"></loading>
  </div>
</template>

<script>

import {addCompany, editCompany} from "@/api/dilivery/company";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "AddEditCompany",
  components: { Loading },
  props:['showDialog','type','selectDetail'],
  data(){
    return{
      title: '',
      loading:false,
      form: {
        id:'',
        quota: '',
        companyName: '',
        taxpayerNumber: '',
        companyAddress: '',
        phone: '',
        depositBank: '',
        bankAccount: '',
        bankLineNumber: '',
        remark: ''
      },

      rules: {
        companyName: [
          {required: true, message: '请输入公司名称', trigger: 'change'}
        ],
        taxpayerNumber: [
          {required: false, message: '请输入纳税人识别号', trigger: 'change'}
        ],
        companyAddress: [
          {required: false, message: '请输入公司地址', trigger: 'change'}
        ],
        phone: [
          {required: false, message: '请输入联系电话', trigger: 'change'}
        ],
        depositBank: [
          {required: false, message: '请输入开户行名称', trigger: 'change'}
        ],
        bankAccount: [
          {required: false, message: '请输入银行账户', trigger: 'change'}
        ],
        bankLineNumber: [
          {required: false, message: '请输入银行行号', trigger: 'change'}
        ],
        quota: [
          { required: false, message: '请输入额度', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (isNaN(value)) {
                return callback(new Error('请输入数字值'));
              }
              if (value < 0) {
                return callback(new Error('金额必须大于等于0'));
              }
              return callback(); // 验证通过
            }, trigger: 'change'
          }
        ],
        remark: [
          {message: '请输入备注', trigger: 'change'}
        ],
      },
    }
  },
  watch:{
    type:{
      handler(newVal){
        if (newVal){
          if(newVal==='add'){
            this.title='添加公司信息'
          }else {
            this.title='修改公司信息'
          }
        }
      },
      immediate:true
    },
    selectDetail:{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.form.id = newVal.id
          this.form.quota = newVal.quota
          this.form.companyName = newVal.companyName
          this.form.taxpayerNumber = newVal.taxpayerNumber
          this.form.companyAddress = newVal.companyAddress
          this.form.phone = newVal.phone
          this.form.depositBank = newVal.depositBank
          this.form.bankAccount = newVal.bankAccount
          this.form.bankLineNumber = newVal.bankLineNumber
          this.form.remark = newVal.remark
        }
      },
      immediate:true
    }
  },
  methods:{
    handle() {
      this.$refs.form.validate(valid=>{
        if(valid){
          this.loading = true
          let ApiMethod = this.type === 'add' ? addCompany : editCompany
          ApiMethod(this.form).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.$emit('submit', 'confirm')
              this.$messageUi.success('提交成功')
            }
          }).catch(err => {
            this.loading = false
          })
        }else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      })
    },
    cancel(){
      this.$emit('submit','cancel')
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixins.scss";

.el-dialog-div {
  @include thin-scrollbar(8px, #888);
  max-height: 60vh;
  /* 你还可以在这个类里写其他样式 */
  background: #fff;
}

.upload-demo {
  margin-top: 20px;
}

.upload-container {
  display: flex;
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中 */
}

.titlehand {
  display: flex;
  justify-content: center;
}
</style>